import { ClientsAPI } from '@/api';

export const ClientsStore = {
  namespaced: true,
  state: {
    data: [],
    selected: {},
    show_modal: false,
    mode: '', // create || edit
  },
  mutations: {

    openModal(state) {
      state.show_modal = true;
    },

    toggleModal(state, status) {
      state.show_modal = status;
    },

    closeModal(state) {
      state.show_modal = false;
    },

    setData(state, data) {
      state.data = data;
    },

    setForEdit(state, data) {
      state.selected = _.cloneDeep(data);
      state.mode = 'edit';
    },

    setForCreate(state) {
      state.selected = _.cloneDeep(ForumDTO);
      state.mode = 'create';
    },
  },
  actions: {

    updateData({ state, commit }) {
      return ClientsAPI.selectAll().then(res => {
        commit('setData', res.data);
      })
    },

    async save({ state, commit, dispatch }) {
      if(state.mode === 'create') {
        await ClientsAPI.create(state.selected)
      } else {
        await ClientsAPI.update(state.selected._id, state.selected)
      }
      await dispatch('updateData');
      commit('closeModal');
    },

    async remove({ dispatch }, item) {
      await ClientsAPI.remove(item._id)
      await dispatch('updateData');
    },
  },
  getters: {

    data(state) {
      return state.data;
    },

    mode(state) {
      return state.mode;
    },

    selected(state) {
      return state.selected;
    },

    showModal(state) {
      return state.show_modal;
    },
  }
};
